'use client';

import { isValidUserRole, useSession } from '@repo/auth';
import { useEffect, useRef } from 'react';
import { gtmDataLayerAdapter } from '../gtm-data-layer-adapter';

export function useIdentifyUser(): void {
  const { data: session } = useSession();
  const identifiedForRef = useRef<string | null>(null);

  useEffect(() => {
    const user = session?.user;
    if (!user?.id) {
      return;
    }
    if (identifiedForRef.current === user.id) {
      return;
    }
    identifiedForRef.current = user.id;

    const role = user.role;
    const isStaff = typeof role === 'string' && isValidUserRole(role);

    gtmDataLayerAdapter.identify(user.id);
    gtmDataLayerAdapter.setUserProperty('logged_in', 'true');
    gtmDataLayerAdapter.setUserProperty('user_role', isStaff ? role : 'user');
    gtmDataLayerAdapter.setUserProperty('traffic_type', isStaff ? 'internal' : 'external');
  }, [session]);
}
